<template>
  <div>
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
.disalju {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
body {
  font-family: "Helvetica Neue", "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei UI", "Microsoft YaHei", Arial, sans-serif !important;

  &::-webkit-scrollbar {
    /* 设置右侧下拉条宽度 */
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    /* 设置右侧下拉条颜色 */
    background-color: #c2c2c2;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track-piece {
    /* 设置右侧下拉条背景颜色 */
    background-color: #fff;
  }
}
</style>
